import React from 'react';

import { Header as HeaderOrganisms } from '@bizapp-lp/home/organisms/Header';
import {
  HeaderContent,
  HeaderContentDrawer,
} from '@bizapp-lp/home/organisms/HeaderMenu';

export interface HeaderProps {
  disableButton?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ disableButton }) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const headerContent = {
    process: {
      title: 'Process',
      items: [
        {
          imgSrc: `${process.env.PUBLIC_URL}/images/home-serviceicon-workflow.png`,
          imgAlt: 'Workflow',
          text: 'Workflow',
          onClick: () => window.open('/workflow/', '_blank'),
        },
        {
          imgSrc: `${process.env.PUBLIC_URL}/images/home-serviceicon-ess.png`,
          imgAlt: 'Enterprise Spreadsheet',
          text: 'Enterprise Spreadsheet',
          onClick: () => window.open('./ess/', '_blank'),
        },
        {
          imgSrc: `${process.env.PUBLIC_URL}/images/home-serviceicon-ebm.png`,
          imgAlt: 'EBM',
          text: 'EBM',
          onClick: () => window.open('./ebm/', '_blank'),
        },
      ],
      hoverColor: '#0ec6bd',
    },
    communication: {
      title: 'Communication',
      items: [
        {
          imgSrc: `${process.env.PUBLIC_URL}/images/home-serviceicon-pjb.png`,
          imgAlt: 'Project Board',
          text: 'Project Board',
          onClick: () => window.open('./pjb/', '_blank'),
        },
        {
          imgSrc: `${process.env.PUBLIC_URL}/images/home-serviceicon-pjr.png`,
          imgAlt: 'Project Room',
          text: 'Project Room',
          onClick: () => window.open('./pjr/', '_blank'),
        },
      ],
      hoverColor: '#4e7ff2',
    },
    knowledge: {
      title: 'Knowledge',
      items: [
        {
          imgSrc: `${process.env.PUBLIC_URL}/images/home-serviceicon-chatbot.png`,
          imgAlt: 'Chatbot',
          text: 'Chatbot',
          onClick: () => window.open('./chatbot/', '_blank'),
        },
      ],
      hoverColor: '#2ca1db',
    },
    disableButton: disableButton,
    onClick: () => window.open('./contact', '_self'),
  };

  return (
    <HeaderOrganisms>
      {width >= 768 ? (
        <HeaderContent {...headerContent} />
      ) : (
        <HeaderContentDrawer {...headerContent} />
      )}
    </HeaderOrganisms>
  );
};
